import { Params, useParams } from "react-router-dom";
import { RoutePaths } from "../RoutePaths";
import { NewEntryFab } from "../playlist/edit/NewEntryFab";
import { generateId } from "../common/UrlFriendlyNanoIdGeneration";
import { ItemsTable } from "./ItemsTable";
import { useState } from "react";
import { Container } from "reactstrap";
import MainMenu from "../menuandheader/MainMenu";

export const bucketParamKey = "bucket";

export function Items() {
  const params: Readonly<Params<string>> = useParams();

  const optionalBucket = params[bucketParamKey];
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);

  return (
    <>
      <MainMenu
        isMainMenuOpen={isMainMenuOpen}
        setIsMainMenuOpen={setIsMainMenuOpen}
      />
      <Container fluid={true}>
        {optionalBucket && (
          <>
            <ItemsTable
              bucket={optionalBucket}
              setIsMainMenuOpen={setIsMainMenuOpen}
            />

            <NewEntryFab
              to={RoutePaths.toNewItem(optionalBucket, generateId())}
            />
          </>
        )}
      </Container>
    </>
  );
}
